module.exports = __webpack_public_path__ + "img/xbox-4.a3127a12.png";